/**
 * @param {unknown} value
 * @param {string} emptyDisplay
 * @returns {string}
 */
export function formatCellForExport(value, emptyDisplay) {
  if (value === null || value === undefined || value === '') {
    return emptyDisplay;
  }
  if (value instanceof Date) {
    return value.toISOString();
  }
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
}

/**
 * Builds AOA matrix: [headerRow, ...dataRows] — all string cells for CSV / Excel.
 *
 * @param {ReadonlyArray<Record<string, unknown>>} rows
 * @param {ReadonlyArray<string>} columnKeys
 * @param {ReadonlyArray<string>} headerLabels
 * @param {string} emptyDisplay
 * @returns {string[][]}
 */
export function buildStringMatrix(rows, columnKeys, headerLabels, emptyDisplay) {
  if (!columnKeys.length) {
    return [];
  }
  const labels = columnKeys.map((_, i) => String(headerLabels[i] ?? columnKeys[i] ?? ''));
  const headerRow = labels;
  const dataRows = rows.map((row) =>
    columnKeys.map((key) => formatCellForExport(row[key], emptyDisplay))
  );
  return [headerRow, ...dataRows];
}
